import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetWritingInstrumentTypes = ():{ writingInstrumentTypes: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelValuePair[], AxiosError>('/marker/getWritingInstrumentTypes',
    (url) => fetcher(url));

  return {
    writingInstrumentTypes: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetWritingInstrumentTypes;
